import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { hotOffersApi } from '@/entities/hot-offers';

import { useHotOffersStore } from './use-hot-offers-store';

export function useHotOffers() {
  const hotOffersStore = useHotOffersStore();
  const {
    origCity,
    hotCities,
    hotCountries,
    origCityCode,
    destCountryCode,
    destinationCountryIndex,
    countryCodeList,
    isCitiesLoading,
    isCountriesLoading,
    hotCitiesCodes,
  } = storeToRefs(hotOffersStore);

  const router = useRouter();

  function openDestCountry(countryCode: string) {
    hotOffersStore.changeDestCountryCode(countryCode);
    router.push({
      name: 'HotOffers',
      params: {
        origCity: origCityCode.value,
        destCountry: countryCode,
      },
    });
  }

  const destCityCode = ref<string | null>(null);

  function changeDestCityCode(cityCode: string) {
    destCityCode.value = cityCode;
  }

  const { hotRoutes, isRoutesLoading } = hotOffersApi.useHotRoutesQuery({
    origCityCode,
    destCityCode,
  });

  return {
    origCity,
    origCityCode,
    isRoutesLoading,
    isCitiesLoading,
    isCountriesLoading,
    countryCodeList,
    openDestCountry,
    changeDestCityCode,
    destCountryCode,
    destinationCountryIndex,
    changeDestCountryCode: hotOffersStore.changeDestCountryCode,
    changeOrigCityCode: hotOffersStore.changeOrigCityCode,
    hotCountries,
    hotCities,
    destCityCode,
    hotRoutes,
    hotCitiesCodes,
  };
}
